import React from "react"
import clsx from "clsx"
import { useTranslation } from "react-i18next"

import { moment, thousandSeparator } from "utils"
import classes from "./CashManagmentCard.module.scss"

const CashManagmentCard = props => {
  const { item } = props

  const [t] = useTranslation()

  return (
    <div className={classes["card"]}>
      <div className={classes["amount"]}>
        <div
          className={clsx(
            classes["in"],
            item.type === "out" && classes["out"]
          )}
        >
          {item.type === "out" ? t("برداشت") : t("واریز")}{" "}
          {thousandSeparator(item.amount)}
        </div>
        <div className={classes["label"]}>
          {moment(item.createdAt).format("HH:mm")}
        </div>
      </div>
      {
        !!item.comment &&
        <div className={classes["comment"]}>
          {item.comment}
        </div>
      }
    </div>
  )
}

export default CashManagmentCard